export enum EducationLevel {
  /**
   * No formal education
   */
  NoFormalEducation = 'no-formal-education',

  /**
   * Primary education
   */
  PrimaryEducation = 'primary-education',

  /**
   * Basic education
   */
  BasicEducation = 'basic-education',

  /**
   * Secondary education
   */
  SecondaryEducation = 'secondary-education',

  /**
   * Vocational/Technical training
   */
  VocationalTechnicalTraining = 'vocational-technical-training',

  /**
   * Bachelor's degree
   */
  BachelorsDegree = 'bachelors-degree',

  /**
   * Postgraduate diploma
   */
  PostgraduateDiploma = 'postgraduate-diploma',

  /**
   * Master's degree
   */
  MastersDegree = 'masters-degree',

  /**
   * Doctorate (PhD)
   */
  DoctoratePhd = 'doctorate-phd',

  /**
   * Other
   */
  Other = 'other',
}
